module.exports = __webpack_public_path__ + "img/6_44.cb564966.png";